import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthenticationGuard } from "@bndes/bndes-ux4/bn-seguranca";
import { AgenteFinanceiroResolver } from 'src/app/shared/resolvers/agente-financeiro.resolver';

import { DominiosResolver } from 'src/app/shared/resolvers/dominios.resolver';
import { SolicitacaoHonraPesquisaComponent } from './solicitacao-honra-pesquisa.component';
import { SolicitacaoHonraDetalheComponent } from './solicitacao-honra-detalhe.component';
import { SolicitacaoHonraLotePesquisaComponent } from '../protocolo/solicitacao-honra-lote-pesquisa.component';
import { SolicitacaoHonraLoteEnvioComponent } from '../protocolo/solicitacao-honra-lote-envio.component';
import { SolicitacaoHonraCadastroComponent } from '../protocolo/solicitacao-honra-cadastro.component';
import { JanelaSolicitacaoHonraResolver } from '../janela/janela-solicitacao-honra.resolver';
import { EscolhaModalidadeGuard } from 'src/app/interceptors/escolha-modalidade.guard';
import { JanelaSolicitacaoHonraPesquisaComponent } from '../janela/janela-solicitacao-honra-pesquisa/janela-solicitacao-honra-pesquisa.component';

const routes: Routes = [
  {
    path: 'solicitacoes-honra/lote',
    component: SolicitacaoHonraLotePesquisaComponent,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    data: { canReuse: true }
  },
  {
    path: 'solicitacoes-honra/lote/envio',
    component: SolicitacaoHonraLoteEnvioComponent,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    resolve: {
    	janelaAtual: JanelaSolicitacaoHonraResolver
    }, 
    data: { canReuse: false }
  },
  {
    path: 'solicitacoes-honra/pesquisa',
    component: SolicitacaoHonraPesquisaComponent,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    resolve: {
      agentes: AgenteFinanceiroResolver,
      dominios: DominiosResolver,
      janelaAtual: JanelaSolicitacaoHonraResolver
    },
    data: { canReuse: false }
  },
  {
    path: 'solicitacoes-honra/cadastro',
    component: SolicitacaoHonraCadastroComponent,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    resolve: {
      agentes: AgenteFinanceiroResolver,
    },    
    data: { canReuse: false }
  },  
  {
    path: 'solicitacoes-honra/:id',
    component: SolicitacaoHonraDetalheComponent,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    resolve: {
      agentes: AgenteFinanceiroResolver,
      dominios: DominiosResolver
    },
    data: { canReuse: false }
  },
  {
    path: 'solicitacoes-honra/janelas/pesquisa',
    component: JanelaSolicitacaoHonraPesquisaComponent,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    data: { canReuse: false }
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SolicitacaoHonraRoutingModule { }
